import { render, staticRenderFns } from "./ChatMessage.vue?vue&type=template&id=59c6e9f8&scoped=true"
import script from "./ChatMessage.vue?vue&type=script&lang=js"
export * from "./ChatMessage.vue?vue&type=script&lang=js"
import style0 from "../../../assets/css/chat.css?vue&type=style&index=0&id=59c6e9f8&prod&scoped=true&lang=css&external"
import style1 from "./ChatMessage.vue?vue&type=style&index=1&id=59c6e9f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c6e9f8",
  null
  
)

export default component.exports